import { blogPath } from '../../lib/blogTopics';
import { blogImages, blogText, blogExcerpt } from '../../lib/blogData';
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ImageSlider from "../common/ImageSlider/ImageSlider";
import "./BlogCard.scss";

const BlogCard = ({ blog }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const title = blogText(blog, "title", i18n.language);
  const description =
    blogText(blog, "description", i18n.language);

  const images = blogImages(blog);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const locale = i18n.language === "fa" ? "fa-IR" : "en-US";
    return date.toLocaleDateString(locale, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="blog-card" role="link" tabIndex={0} onKeyDown={e => { if (e.target === e.currentTarget && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); navigate(blogPath(blog)); } }} onClick={() => navigate(blogPath(blog))}>
      <div className="blog-card-image">
        <ImageSlider images={images} />
      </div>

      <div className="blog-card-content">
        <strong className="blog-topic">{blog.topic}</strong>
        <div className="blog-card-header">
          <h3 className="blog-card-title">{title}</h3>
          <span className="blog-card-date">{formatDate(blog.created_at)}</span>
        </div>

        <p className="blog-card-description">{blogExcerpt(description)}</p>
      </div>
    </div>
  );
};

export default BlogCard;
